import { ArrowRightIcon, ArrowUpRightIcon, MapPinIcon, SearchIcon, WrenchIcon } from "lucide-react"

import Logo from "@/assets/KC_logo_2008.webp"
import { buttonVariants } from "@/components/ui/shadcn/button"
import { Card } from "@/components/ui/shadcn/card"

const footerServiceItems = [
  {
    title: "Поиск по артикулу",
    description: "Найдите любую запчасть по артикулу",
    href: "/ssp",
    icon: SearchIcon,
  },
  {
    title: "Запчасти для ТО",
    description: "Расходники для планового обслуживания",
    href: "/#maintenance-parts",
    icon: WrenchIcon,
  },
  {
    title: "Магазины на карте",
    description: "Адреса и контакты магазинов",
    href: "/#store-map",
    icon: MapPinIcon,
  },
]

const footerLinkGroups = [
  {
    title: "Покупателям",
    links: [
      { label: "Каталог", href: "/" },
      { label: "Популярные товары", href: "/collections/popular" },
      { label: "Новинки", href: "/collections/new" },
      { label: "Избранное", href: "/profile/favorites" },
      { label: "Корзина", href: "/cart" },
    ],
  },
  {
    title: "Сервисы",
    links: [
      { label: "Личный кабинет", href: "/profile" },
      { label: "Поиск по артикулу", href: "/ssp" },
      { label: "Магазины на карте", href: "/#store-map" },
    ],
  },
  {
    title: "Компания",
    links: [
      { label: "О компании", href: "/about" },
      { label: "Пользовательское соглашение", href: "/about/terms" },
      { label: "Политика конфиденциальности", href: "/about/privacy" },
    ],
  },
]

const StoreFooter = () => (
  <footer data-scaena-ui className="relative mt-8 !bg-transparent !p-0 !text-foreground md:mt-10">
    <Card variant="glass" className="relative overflow-hidden px-0 py-0">
      <div aria-hidden className="absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-primary/24 to-transparent" />
      <div className="grid gap-8 p-5 sm:p-6 lg:grid-cols-12 lg:gap-x-8 lg:p-8">
        <div className="flex min-w-0 flex-col gap-6 lg:col-span-3">
          <div className="flex min-w-0 flex-col items-start gap-3">
            <a href="/" aria-label="КЦ Авто — главная">
              <img src={Logo} alt="КЦ Авто" className="h-11 w-auto sm:h-12" style={{ width: "auto" }} />
            </a>
            <p className="max-w-[22rem] text-sm leading-6 text-muted-foreground">КЦ Авто — сеть магазинов автозапчастей</p>
          </div>

          <div className="flex flex-col gap-1" aria-label="Быстрые переходы">
            {footerServiceItems.map((item) => {
              const Icon = item.icon

              return (
                <a
                  key={item.title}
                  href={item.href}
                  className="group/service grid grid-cols-[32px_minmax(0,1fr)] items-center gap-3 rounded-[var(--scaena-radius-inner)] py-2 transition-colors duration-200 hover:text-primary"
                >
                  <span className="flex size-8 items-center justify-center rounded-[var(--scaena-radius-compact)] bg-primary/8 text-primary transition-[background-color,color,transform] duration-200 group-hover/service:-translate-y-0.5 group-hover/service:bg-primary group-hover/service:text-primary-foreground">
                    <Icon className="size-4" />
                  </span>
                  <span className="min-w-0">
                    <span className="block text-sm font-[550] leading-snug text-foreground transition-colors duration-200 group-hover/service:text-primary">{item.title}</span>
                    <span className="mt-0.5 block text-xs leading-5 text-muted-foreground">{item.description}</span>
                  </span>
                </a>
              )
            })}
          </div>
        </div>

        <div className="grid gap-5 sm:grid-cols-3 lg:col-span-6">
          {footerLinkGroups.map((group) => (
            <nav key={group.title} className="min-w-0" aria-label={group.title}>
              <h3 className="text-sm font-[550] text-foreground">{group.title}</h3>
              <ul className="mt-3 flex flex-col gap-2.5">
                {group.links.map((link) => (
                  <li key={link.label}>
                    <a
                      href={link.href}
                      className="group/link inline-flex items-center gap-1.5 text-sm font-[550] leading-snug text-muted-foreground transition-colors duration-200 hover:text-primary"
                    >
                      <span>{link.label}</span>
                      <ArrowUpRightIcon className="size-3 shrink-0 opacity-0 transition-[opacity,transform] duration-200 group-hover/link:translate-x-0.5 group-hover/link:-translate-y-0.5 group-hover/link:opacity-100" />
                    </a>
                  </li>
                ))}
              </ul>
            </nav>
          ))}
        </div>

        <div className="flex h-fit self-start flex-col gap-4 lg:col-span-3">
          <div className="rounded-[var(--scaena-radius-inner)] border border-primary/10 bg-primary/7 p-4">
            <div className="flex items-center gap-2 text-sm font-[550] text-primary">
              <SearchIcon className="size-4" />
              Поиск запчастей по артикулу
            </div>
            <p className="mt-2 text-sm leading-6 text-muted-foreground">
              Укажите артикул любой запчасти, выберите из предложений множества складов и получите заказ в удобном магазине
            </p>
            <a href="/ssp" className={buttonVariants({ size: "sm", className: "mt-4 w-full" })}>
              Перейти к поиску
              <ArrowRightIcon data-icon="inline-end" />
            </a>
          </div>
          <span className="text-xs font-[550] text-muted-foreground lg:text-right">© 2026 КЦ Авто</span>
        </div>
      </div>
    </Card>
  </footer>
)

export default StoreFooter
